module.exports = __webpack_public_path__ + "img/1.da794580.jpg";